import { reportError } from "@bookingcom/flights-core";
import { MpContextProvider } from "@bookingcom/mp-flights";
import { customGoal, stage, trackWithDefaultStage } from "@flights/et-universal";
import React from "react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import usePointOfSale from "../../../hooks/usePointOfSale.js";
import useUserAgent from "../../../hooks/useUserAgent.js";
import flights_insurance_entry_exp from "../../../utils/experiments/insurance/flights_insurance_entry_exp.js";
export const MultiProductWrapper = (props) => {
    const { children } = props;
    const globalContext = useGlobalContext();
    const { isMobile, isTablet } = useUserAgent();
    const { marketingTrackingVariables, features, etStateBlob = "" } = useGlobalContext();
    const isMPEnabled = !!features["FLIGHTS_ENABLE_BCOM_INSURANCE_FE_COMPONENT_IN_FLIGHTS_FUNNEL"];
    const includeCredentials = !!features["FLIGHTS_WEB_MP_SHOP_ALLOW_CREDENTIALS"];
    const affiliateId = marketingTrackingVariables?.aid;
    const platform = isMobile || isTablet ? "mdot" : "www";
    const pointOfSale = usePointOfSale();
    const trackExperiment = React.useCallback((tagName) => trackWithDefaultStage(tagName, 1), []);
    return isMPEnabled ? (React.createElement(MpContextProvider, { value: {
            country: globalContext.ipCountry || "",
            pointOfSale,
            currency: globalContext.currencyCode || "",
            language: globalContext.lang || "",
            locale: globalContext.locale || "",
            env: globalContext.env || "dqs",
            etStateBlob,
            affiliateId: Number(affiliateId || 0),
            platform: platform,
            includeCredentials,
            reportError: reportError,
            trackExperiment,
            trackExperimentStage: stage,
            trackCustomGoal: customGoal,
            flightsInsuranceExperiment: flights_insurance_entry_exp
        }, mpShopUrl: "/api/multiProduct" }, children)) : (children);
};
